import React from 'react';
import { motion } from 'framer-motion';
import { Hand, Sparkles, Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    title: 'Protocolo de Crisis "No le escribas"',
    desc: 'Guía rápida para esos momentos en que sientes urgencia de buscarlo, escribirle o revisar sus redes. Qué hacer minuto a minuto para no ceder al impulso.',
    value: 17,
    num: '01',
    icon: <Hand size={28} strokeWidth={1.5} data-id="element-46" />
  }, {
    title: 'Checklist "Limpieza de Huellas"',
    desc: 'Lista práctica para detectar objetos, rutinas y espacios que siguen manteniendo el vínculo activo sin que lo notes, y cómo neutralizarlos.',
    value: 12,
    num: '02',
    icon: <Sparkles size={28} strokeWidth={1.5} data-id="element-47" />
  }];
  return <section className="py-24 px-4 bg-gradient-to-br from-primary/8 via-cream to-soft/20 relative overflow-hidden" data-id="element-48">
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/15 rounded-full blur-3xl pointer-events-none" data-id="element-49"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-50">
        <div className="text-center mb-14" data-id="element-51">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-accent to-primary text-white text-xs font-bold px-5 py-2.5 rounded-full uppercase tracking-wider mb-6 shadow-lg" data-id="element-52">
            <Gift size={14} data-id="element-53" /> DISPONIBLES SOLO HOY
          </div>
          <h2 className="font-serif font-bold text-3xl md:text-5xl text-primary mb-4" data-id="element-54">
            Bonos de Acción Rápida
          </h2>
          <p className="font-sans text-ink/70 max-w-xl mx-auto" data-id="element-55">
            Diseñados para acompañarte en los momentos más difíciles del
            proceso.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-56">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white rounded-2xl p-7 md:p-8 border-2 border-gold/40 shadow-xl relative hover:-translate-y-1 transition-transform" data-id="element-57">
              <div className="absolute -top-5 -right-5 w-14 h-14 bg-gradient-to-br from-gold to-accent text-white rounded-full flex items-center justify-center font-serif font-bold text-xl shadow-xl border-4 border-cream" data-id="element-58">
                {bono.num}
              </div>

              <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-accent/15 to-gold/15 text-accent flex items-center justify-center mb-4" data-id="element-59">
                {bono.icon}
              </div>

              <h3 className="font-serif font-bold text-xl md:text-2xl text-primary mb-3 pr-10 leading-tight" data-id="element-60">
                {bono.title}
              </h3>
              <p className="text-ink/75 font-sans text-sm leading-relaxed mb-5" data-id="element-61">
                {bono.desc}
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-soft/30" data-id="element-62">
                <span className="bg-relief text-white text-xs font-extrabold px-3 py-1.5 rounded-full" data-id="element-63">
                  GRATIS HOY
                </span>
                <span className="text-urgency font-bold text-sm line-through" data-id="element-64">
                  Valor ${bono.value}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}